import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { navItems, hotel } from "../mock";
import { useReservation } from "./ReservationModal";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { openReservation } = useReservation();

  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // On non-home pages the header is always solid
  const solid = scrolled || !isHome;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        solid
          ? "bg-[#fdfbf7]/95 backdrop-blur-md shadow-[0_1px_20px_-8px_rgba(0,0,0,0.25)] py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center group">
          <img
            src={solid ? hotel.logoDark : hotel.logoWhite}
            alt={hotel.name}
            className={`w-auto transition-all duration-500 ${
              solid ? "h-9 md:h-10" : "h-11 md:h-14"
            }`}
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-9">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link text-[13px] tracking-[0.12em] uppercase font-500 transition-colors ${
                location.pathname === item.path ? "active" : ""
              } ${
                solid
                  ? "text-[#4a443b] hover:text-[#b8893a]"
                  : "text-white/90 hover:text-white"
              } ${location.pathname === item.path && solid ? "text-[#b8893a]" : ""}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <a
            href={`tel:${hotel.phones[0].replace(/\s/g, "")}`}
            className={`hidden xl:flex items-center gap-2 text-[13px] font-500 transition-colors ${
              solid ? "text-[#4a443b]" : "text-white/90"
            }`}
          >
            <Phone size={15} className="text-[#b8893a]" />
            {hotel.phones[0]}
          </a>
          <button
            onClick={openReservation}
            className="btn-gold hidden sm:inline-block px-6 py-3 rounded-sm"
          >
            Rezervasyon
          </button>
          <button
            onClick={() => setOpen((v) => !v)}
            className={`lg:hidden ${solid ? "text-[#2b2620]" : "text-white"}`}
            aria-label="Menü"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ${
          open ? "max-h-[420px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <nav className="bg-[#fdfbf7] px-6 py-5 flex flex-col gap-1 border-t border-[#e9e0cf] mt-3">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`py-3 text-[15px] tracking-wide border-b border-[#efe7d7] last:border-0 ${
                location.pathname === item.path
                  ? "text-[#b8893a] font-500"
                  : "text-[#4a443b]"
              }`}
            >
              {item.label}
            </Link>
          ))}
          <button
            onClick={openReservation}
            className="btn-gold mt-4 px-6 py-3 rounded-sm"
          >
            Rezervasyon Yap
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
